import Footer from './Footer.vue';

export default Footer;



// WEBPACK FOOTER //
// ./src/pages/profile/views/certificate/components/footer/index.ts